import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { AccountStorage } from "@services/account";
import account from '@mixin/account';
var accountStorage = new AccountStorage();
export default {
  data: function data() {
    return {
      selectphone: this.phone[0],
      nextStep: 1,
      newPhone: null,
      pwd: null,
      showTime: false,
      time: 90,
      showTime_second: false,
      time_second: 90,
      code: null,
      seconde_code: null //绑定新号码验证码
    };
  },
  props: ["isExistPhone", "phone"],
  //是否绑定了号码
  mixins: [account],
  methods: {
    changeInvitationRole: function changeInvitationRole(val) {
      this.selectphone = val;
    },
    back: function back() {
      if (this.nextStep == "3") {
        this.$emit("back", true);
      } else {
        this.$emit("back");
      }
    },
    //下一步
    next: function next() {
      if (this.nextStep == 1 && this.isExistPhone) {
        //变更号码,第一步验证原来号码
        this.valid_changePhone();
      }
      if (this.nextStep == 2 && this.isExistPhone) {
        //变更号码,第二步保存新号码
        this.save_changePhone();
      }
      if (this.nextStep == 1 && !this.isExistPhone) {
        //绑定号码,第一步验证原密码
        this.valid_bindPhone();
      }
      if (this.nextStep == 2 && !this.isExistPhone) {
        //绑定号码,第二步保存新号码
        this.save_bindPhone();
      }
    },
    valid_changePhone: function valid_changePhone() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var code, url, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              code = _this.code;
              if (code) {
                _context.next = 4;
                break;
              }
              _this.$messageTip("请输入验证码", "error");
              return _context.abrupt("return");
            case 4:
              url = "/pjyy-deepexi-user-center/api/v1/customer/changePhoneFirstCheck?code=".concat(code, "&phone=").concat(_this.selectphone);
              _context.next = 7;
              return _this.$getHttpClient().get(url);
            case 7:
              res = _context.sent;
              if (res.data.code == "200") {
                _this.nextStep = "2";
              } else {
                _this.$messageTip(res.data.msg, "error");
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    save_changePhone: function save_changePhone() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var code, phone, test, url, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              code = _this2.seconde_code;
              phone = _this2.newPhone;
              test = /^1(3[0-9]|4[01456879]|5[0-3,5-9]|6[2567]|7[0-8]|8[0-9]|9[0-3,5-9])\d{8}$/;
              if (test.test(phone)) {
                _context2.next = 6;
                break;
              }
              _this2.$messageTip("请输入正确手机号", "error");
              return _context2.abrupt("return");
            case 6:
              if (code) {
                _context2.next = 9;
                break;
              }
              _this2.$messageTip("请输入验证码", "error");
              return _context2.abrupt("return");
            case 9:
              url = "/pjyy-deepexi-user-center/api/v1/customer/changePhoneSecond?phone=".concat(phone, "&code=").concat(code, "&oldPhone=").concat(_this2.selectphone);
              _context2.next = 12;
              return _this2.$getHttpClient().get(url);
            case 12:
              res = _context2.sent;
              if (res.data.code == "200") {
                _this2.$messageTip("变更成功");
                _this2.nextStep = "3";
                localStorage.setItem("currentLoggedInPhoneNumber", _this2.newPhone);
                setTimeout(function () {
                  _this2.toLogOut();
                }, 2000);
              } else {
                _this2.$messageTip(res.data.msg, "error");
              }
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    valid_bindPhone: function valid_bindPhone() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var pwd, url, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              pwd = _this3.pwd;
              if (pwd) {
                _context3.next = 4;
                break;
              }
              _this3.$messageTip("请输入登录密码", "error");
              return _context3.abrupt("return");
            case 4:
              url = "/pjyy-deepexi-user-center/api/v1/customer/bindPhoneFirtCheck?pwd=".concat(pwd);
              _context3.next = 7;
              return _this3.$getHttpClient().get(url);
            case 7:
              res = _context3.sent;
              if (res.data.code == "200") {
                _this3.nextStep = "2";
              } else {
                _this3.$messageTip(res.data.msg, "error");
              }
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    save_bindPhone: function save_bindPhone() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var code, phone, test, url, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              code = _this4.seconde_code;
              phone = _this4.newPhone;
              test = /^1(3[0-9]|4[01456879]|5[0-3,5-9]|6[2567]|7[0-8]|8[0-9]|9[0-3,5-9])\d{8}$/;
              if (test.test(phone)) {
                _context4.next = 6;
                break;
              }
              _this4.$messageTip("请输入正确手机号", "error");
              return _context4.abrupt("return");
            case 6:
              if (code) {
                _context4.next = 9;
                break;
              }
              _this4.$messageTip("请输入验证码", "error");
              return _context4.abrupt("return");
            case 9:
              url = "/pjyy-deepexi-user-center/api/v1/customer/bindPhone?phone=".concat(phone, "&code=").concat(code);
              _context4.next = 12;
              return _this4.$getHttpClient().get(url);
            case 12:
              res = _context4.sent;
              if (res.data.code == "200") {
                _this4.$messageTip("绑定成功");
                _this4.nextStep = "3";
              } else {
                _this4.$messageTip(res.data.msg, "error");
              }
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    //获取验证码
    getCode: function getCode() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var url, res, that, timer;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url = "/pjyy-deepexi-user-center/api/v1/customer/changPhoneSendCode?phone=".concat(_this5.selectphone);
              _context5.next = 3;
              return _this5.$getHttpClient().get(url);
            case 3:
              res = _context5.sent;
              if (res.data.code == "200") {
                _this5.showTime = true;
                //倒计时
                that = _this5;
                timer = setInterval(function () {
                  that.time--;
                  if (that.time == 0) {
                    clearInterval(timer);
                    that.time = 90;
                    _this5.showTime = false;
                  }
                }, 1000);
              } else {
                _this5.$messageTip(res.data.msg, "error");
              }
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getSecondCode: function getSecondCode() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var phone, url, res, that, timer;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              phone = _this6.newPhone;
              url = "/pjyy-deepexi-user-center/api/v1/customer/sendBindPhoneCode?phone=".concat(phone, "&");
              _context6.next = 4;
              return _this6.$getHttpClient().get(url);
            case 4:
              res = _context6.sent;
              if (res.data.code == "200") {
                _this6.showTime_second = true;
                //倒计时
                that = _this6;
                timer = setInterval(function () {
                  that.time_second--;
                  if (that.time_second == 0) {
                    clearInterval(timer);
                    that.time_second = 90;
                    _this6.showTime_second = false;
                  }
                }, 1000);
              } else {
                _this6.$messageTip(res.data.msg, "error");
              }
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    //绑定手机号
    bind: function bind() {}
  }
};